export const shyComponentChangeEventName = "shycomponentchange";
